export default __webpack_public_path__ + "static/media/gorin_blue_2.0cf3a76a.png";